/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { deviceInfoSchema } from "./deviceInfoSchema.ts";

export const deviceCurrentRetrieveStatus200Schema = deviceInfoSchema.describe("Сериализатор вывода инфо об устройстве.");

export const deviceCurrentRetrieveResponseSchema = deviceCurrentRetrieveStatus200Schema;
